module.exports = __webpack_public_path__ + "media/images/mobile/dummy06-49eb5336682b00083590a2de100021d0.jpg";